import { isValidElement, type ReactNode } from "react";
import { Tooltip, type TooltipProps } from "@financeable-com-au/financeable-ui";

type TooltipModifier = NonNullable<TooltipProps["modifiers"]>[number];

/**
 * The design system caps tooltips at 230px, which is tight for rich content. That cap is a theme style on the popper,
 * which no prop reaches, so a Popper modifier raises it before the first measurement. Module-level so the array keeps
 * its identity: a new one each render would make the Popper rebuild.
 */
const WIDE_TOOLTIP_MODIFIERS: TooltipModifier[] = [
  {
    name: "richTooltipMaxWidth",
    enabled: true,
    phase: "beforeRead",
    effect: ({ state }) => {
      state.elements.popper.style.maxWidth = "340px";
    },
  },
];

interface RichTooltipProps extends Omit<TooltipProps, "children" | "modifiers"> {
  /** Anything other than a single element is wrapped in a span, since Joy's Tooltip renders nothing else. */
  children: ReactNode;
}

/** Financeable tooltip for titles that hold rich content rather than plain text. */
export const RichTooltip = ({ children, placement = "bottom", ...props }: RichTooltipProps) => (
  <Tooltip {...props} placement={placement} modifiers={WIDE_TOOLTIP_MODIFIERS}>
    {isValidElement(children) ? children : <span>{children}</span>}
  </Tooltip>
);
